import { Model } from '../core/base.model';

import { SimpleEntityActions } from '@app/classes';

export class Password extends Model {
    protected static _resource = 'accountManagement/accounts/:account/password';
    protected static _version = 'v2';
    protected static _type = 'passwords';
    protected static _serializeAttributes = ['value', 'value_confirmation'];

    static permission = new SimpleEntityActions('password', ['create', 'delete']); // why do we have delete here?

    set value(val: string) {
        this._attributes['value'] = val;
        this._attributes['value_confirmation'] = val;
    }
}
